import React, { useState, useEffect } from "react";

import { isMobile } from "react-device-detect";

import { Link, useParams, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

import RouteApi from "../Backend/Backend";

const Header = () => {
  const { id } = useParams();

  const location = useLocation();

  const {
      getNotifications,
    } = RouteApi(); // Destructure function from RouteApi

  const hash = window.location.hash.slice(1);

  const schoolname = localStorage.getItem("schoolname");

  const user = useSelector((state) => state.auth?.user);

  // Get user details
  const fname = user?.ghostuser || "";

  const [header, setHeader] = useState("");

  useEffect(() => {
    const path = location.pathname.replace(`/${id}`, "");

    const titleMap = {
      "/login": "Login",
      "/verify-otp": "Verify OTP",
      "/dashboard": "Dashboard",
      "/control": "Control Centre",
      "/account": "Account Centre",
      "/message": "CRM - Messages",
      "/services": "Services",
      "/cbt": "CBT Center",
      "/exercise": "Exercise Center",
      "/results": "Results Workspace",
      "/cbt/create": "CBT Workspace",
      "/exercise/create": "Exercise Workspace",
    };

    // Keep the label in the header and the browser tab in sync.  Dynamic
    // routes (such as a CBT console or a payment) do not have an exact entry
    // in titleMap, so resolve those before falling back to the app name.
    let header = "Smart Edu Admin";
    let pageTitle = "Smart Edu Admin | Smart Edu.";

    if (path.startsWith("/cbt/console")) {
      header = "CBT Console";
      pageTitle = "CBT Console | Smart Edu.";
    } else if (path.startsWith("/profile/students")) {
      header = "Student Profiles";
      pageTitle = "Student Profiles | Smart Edu.";
    } else if (path.startsWith("/profile/teachers")) {
      header = "Teacher Profiles";
      pageTitle = "Teacher Profiles | Smart Edu.";
    } else if (path.startsWith("/pay/")) {
      header = "Payment";
      pageTitle = "Payment | Smart Edu.";
    } else if (titleMap[path]) {
      header = titleMap[path];
      pageTitle = `${titleMap[path]} | Smart Edu.`;
    }

    setHeader(header);
    document.title = pageTitle;
  }, [location, id]);

  return (
    <>
      <div class="docs-header">
        <nav
          class={
            isMobile
              ? "navbar navbar-expand-lg bg-white fixed-top ms-0 py-3 shadow-none row px-3"
              : "navbar navbar-expand-lg row bg-white fixed-top ms-0 py-2 shadow-none px-2"
          }
        >
          <div class="col-lg-2 text-start mb-2 mb-lg-0">
            <div className="d-flex align-items-center">
            <div className="col py-1">
              <div className="fs-t text-purple2 fw-medium ms-lg-2">
                {schoolname}
              </div>
            </div>

            <div className='col-end text-end d-lg-none d-block mb-2' data-bs-toggle="offcanvas" data-bs-target="#menu" aria-controls="menu">
              <div className="btn btn-purple btn-sm rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2">
                  <i class="bi bi-list text-white fs-t"></i>
              </div>
            </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="d-flex align-items-center">
              <div className="col-lg-4 ms-4 d-lg-block d-none">
                <span className="fs-3 fw-medium text-gray-600">{header}</span>
              </div>

              <div className="col-lg-8 col-12 d-flex align-items-center">
                <input
                  type="text"
                  class="form-control form-control-lg bg-back pe-9"
                  placeholder="Search for..."
                />
                <button class="btn btn-purple4 pe-3 ms-n7" type="button">
                  <i class="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>

          <ul class="col-lg-4 navbar-nav flex-row d-none d-lg-flex mt-2 Navbar_navlinks__clVQG text-end ms-lg-10">
            <div
              class={
                hash === "/home"
                  ? "nav-item docs-header-btn ms-4 text-warning cursor-pointer"
                  : "nav-item docs-header-btn ms-4 text-dark cursor-pointer"
              }
              data-bs-toggle="offcanvas"
              data-bs-target="#smart-ai"
              aria-controls="smart-ai"
            >
              <span className="fw-medium fs-4">
                {" "}
                <i class="bi bi-stars text-warning fs-4"></i> Smart Ai
              </span>
            </div>

            <div
              class="nav-item docs-header-btn ms-4 text-dark cursor-pointer"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              <span className="fw-medium fs-3" onClick={() => getNotifications()}>
                <i class="bi bi-bell-fill text-dark"></i>
              </span>
            </div>

            <Link
              to={"../" + id + "/message"}
              class="nav-item docs-header-btn ms-4 text-dark"
            >
              <span className="fw-medium fs-3">
                <i class="bi bi-envelope-fill text-dark"></i>
              </span>
            </Link>

            <li class="nav-item ms-4 text-dark">
              <div className="text-end d-flex">
                <div className="col-2">
                  <span class="avatar avatar-md">
                    <img
                      alt="avatar"
                      src="../assets/images/uploads/avatar.png"
                      class="rounded-circle"
                    />
                  </span>
                </div>

                <div className="col-10 text-start ms-4">
                  <div className="fs-5 fw-medium">{fname}</div>
                  <div className="fs-6 fw-light">Admin</div>
                </div>
              </div>
            </li>
          </ul>
        </nav>

        <div
          class="offcanvas offcanvas-end offcanvas-lg bg-white"
          tabindex="-1"
          id="menu"
          aria-labelledby="offcanvasBottomLabel"
          style={{
              width: "1000px",
          }}
      >
          <div class="offcanvas-header align-items-center pt-3 pb-3">
              <div
                  class="offcanvas-title fs-t2 text-q2"
                  id="offcanvasBottomLabel"
              ></div>

              <button
                  class="btn btn-icon text-purple fw-bold"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
              >
                  <i class="bi bi-x-lg fw-bold fs-t"></i>
              </button>
          </div>
          <div class="offcanvas-body py-0 px-1">

            <div className="d-flex align-items-center px-4 mb-6 mt-0">
              <div className="col-5">
                <div className="card bg-back shadow-none rounded-pill px-3 py-2"
                data-bs-toggle="offcanvas"
                data-bs-target="#smart-ai"
                aria-controls="smart-ai">
                  <span className="text-dark fs-t1">
                    <i class="bi bi-stars text-warning fs-4"></i> Smart Ai
                  </span>
                </div>
              </div>

              <div className="col-2">

              </div>

              <div className="col-2">
                <div
                  class="card bg-purple4 shadow-none rounded-pill px-3 py-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                >
                  <span className="fw-medium fs-3" onClick={() => getNotifications()}>
                    <i class="bi bi-bell-fill text-white ms-1"></i>
                  </span>
                </div>
              </div>

              <div className="col-2 ms-4">
                <Link
                  to={"../" + id + "/message"}
                  class="card bg-purple4 shadow-none rounded-pill px-3 py-2"
                >
                  <span className="fw-medium fs-3">
                    <i class="bi bi-envelope-fill text-white ms-1"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className='px-0 mt-0 mb-12'>
                <Link to={"../" + id + "/dashboard"} className='col-12'>
                    <div className=' pt-0 px-5' data-bs-dismiss="offcanvas">
                        <span className='fs-t text-dark'> <i className='bi bi-house-fill text-success'></i> Dashboard</span>
                    </div>
                </Link>

                <Link to={"../" + id + "/control"} className='col-12 pt-3' >
                    <div className=' pt-4 px-5' data-bs-dismiss="offcanvas">
                        <span className='fs-t text-dark'> <i class="bi bi-building text-warning"></i> Control Centre</span>
                    </div>
                </Link>

                <Link to={"../" + id + "/cbt"} className='col-12 pt-3' >
                    <div className=' pt-4 px-5' data-bs-dismiss="offcanvas">
                        <span className='fs-t text-dark'> <i class="bi bi-pc-display-horizontal text-dark-info"></i> CBT Workspace {" "}
                        <span className="btn btn-sm rounded-pill shadow-none btn-primary">Pro</span>
                        </span>
                    </div>
                </Link>

                <Link to={"../" + id + "/exercise"} className='col-12 pt-3' >
                    <div className=' pt-4 px-5' data-bs-dismiss="offcanvas">
                        <span className='fs-t text-dark'> <i class="bi bi-list-stars text-success"></i> Exercise {" "}
                        <span className="btn btn-sm rounded-pill shadow-none btn-primary">Pro</span>
                        </span>
                    </div>
                </Link>

                <Link to={"../" + id + "/account"} className='col-12 pt-3' >
                    <div className=' pt-4 px-5' data-bs-dismiss="offcanvas">
                        <span className='fs-t text-dark'> <i class="bi bi-bank text-warning"></i> Account Centre {" "}
                        <span className="btn btn-sm rounded-pill shadow-none btn-primary">Pro</span>
                        </span>
                    </div>
                </Link>

                <Link to={"./"} className='col-12 pt-3' >
                    <div className="cursor-pointer">
                      <div
                        className="pt-4 px-5"
                        data-bs-toggle="collapse"
                        data-bs-target="#navUsersCollapse"
                        aria-expanded="false"
                        aria-controls="navUsersCollapse"
                      >
                        <span className="fs-t text-dark">
                          <i className="bi bi-pc-display-horizontal text-pink"></i> Users
                        </span>
                      </div>

                      <div id="navUsersCollapse" className="collapse ms-4" data-bs-parent="#sideNavbar">
                        <div className="d-flex flex-column ms-7">
                          <Link
                            to={`../${id}/profile/teachers`}
                            className="text-dark mt-4"
                          >
                            <i className="bi bi-person-lines-fill fs-t me-2"></i>
                            <span className="fs-t">Teachers</span>
                          </Link>

                          <Link
                            to={`../${id}/profile/students`}
                            className="text-dark mt-3"
                          >
                            <i className="bi bi-person-lines-fill fs-t me-2"></i>
                            <span className="fs-t">Students</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                </Link>

                <Link to={"../" + id + "/results"} className='col-12 pt-3'>
                    <div className=' pt-4 px-5' data-bs-dismiss="offcanvas">
                        <span className='fs-t text-dark'> <i className='bi bi-person-check text-primary'></i> Results </span>
                    </div>
                </Link>

                <Link to={"./"} className='col-12 pt-3'>
                    <div className=' pt-4 px-5'>
                        <span className='fs-t text-dark'> <i className='bi bi-headset text-purple'></i> Contact Us</span>
                    </div>
                </Link>

                <Link to={"/company"} className='col-12 pt-3'>
                    <div className=' pt-4 px-5'>
                        <span className='fs-t text-dark'> <i className='bi bi-power text-success'></i> Logout</span>
                    </div>
                </Link>

                <div className='col-12 pt-4 fixed-bottom'>
                    <div className=' pt-6 px-5'>
                        <div className='text-center mb-2'>
                            <span className='fs-5 text-gray-600'>
                              © All rights reserved {new Date().getFullYear()}. Smart Edu Inc.
                            </span>
                        </div>
                    </div>
                </div>

            </div>
          </div>
        </div>


      </div>
    </>
  );
};

export default Header;
